import React from 'react';
import { Phone, MapPin, Clock } from 'lucide-react';
import { Logo } from './Logo';
import { shopInfo } from '../mock';

export const Footer = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-stone-800 border-t border-stone-700">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <Logo variant="full-light" className="h-16 w-auto" />
            <p className="text-xs text-stone-500">Since {shopInfo.ownedSince}</p>
            <p className="text-sm text-stone-400">
              Classic cuts and timeless style in the heart of Starkville.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-stone-100 font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('about')} className="text-stone-400 hover:text-maroon-700 transition-colors duration-200 text-sm">
                  About Us
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('services')} className="text-stone-400 hover:text-maroon-700 transition-colors duration-200 text-sm">
                  Services
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('reviews')} className="text-stone-400 hover:text-maroon-700 transition-colors duration-200 text-sm">
                  Reviews
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('contact')} className="text-stone-400 hover:text-maroon-700 transition-colors duration-200 text-sm">
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-stone-100 font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm">
                <Phone className="h-4 w-4 text-maroon-700 mt-0.5 flex-shrink-0" />
                <a href={`tel:${shopInfo.phone}`} className="text-stone-400 hover:text-maroon-700 transition-colors duration-200">
                  {shopInfo.phone}
                </a>
              </li>
              <li className="flex items-start space-x-2 text-sm">
                <MapPin className="h-4 w-4 text-maroon-700 mt-0.5 flex-shrink-0" />
                <span className="text-stone-400">
                  {shopInfo.address.fullAddress}
                </span>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-stone-100 font-semibold mb-4">Hours</h4>
            <ul className="space-y-2">
              <li className="flex items-center space-x-2 text-sm">
                <Clock className="h-4 w-4 text-maroon-700 flex-shrink-0" />
                <span className="text-stone-400">Tue-Fri: 9 AM - 5:30 PM</span>
              </li>
              <li className="flex items-center space-x-2 text-sm">
                <Clock className="h-4 w-4 text-maroon-700 flex-shrink-0" />
                <span className="text-stone-400">Sat, Sun, Mon: Closed</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-800 mt-8 pt-8 text-center">
          <p className="text-sm text-stone-400">
            © {new Date().getFullYear()} {shopInfo.name}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
